<template>
  <span>
    <i aria-hidden="true" class="fa fa-external-link" />
    <span v-if="externalLink" class="sr-only">(External link)</span>
    <span class="sr-only">(Opens in a new tab)</span>
  </span>
</template>

<script>

export default {
  name: 'OpensInNewTabIcon',
  props: {
    externalLink: {
      type: Boolean,
      required: false,
      default: false
    },
  }
};
</script>

<style scoped>
.fa-external-link {
  font-size: 1rem;
}
</style>
